import { QR_TYPE, QR_TYPE_TO_PARAM } from '../features/generator/generatorTypes'

export const SEARCH_PARAMS = {
	modals: {
		key: 'm',
		recoverPasswordConfirmation: 'recoveryConfirm',
		resetLinkExpired: 'resetLinkExpired',
		resetPassword: 'resetPassword',
		statusRestricted: 'statusRestricted',
	},
	auth: {
		key: 'auth',
		login2fa: '2fa',
		userId: 'userId',
		redirectUrl: 'redirectUrl',
		surface: 'auth-surface',
		surfaceModal: 'modal',
		autoLogin: 'autologin',
	},
	cancelSubscription: {
		// MYQRCODE-10803 AC#3: cancellation emails link here with ?src=email so
		// the request_uri shows up distinctly in ingress logs vs. the public
		// form's plain URL — metrics only, qr-api doesn't read this value.
		sourceKey: 'src',
		sourceEmail: 'email',
	},
}

export const BUILDER_EDIT_MODES = {
	CONTENT: 'content',
	TYPE: 'type',
}

const GENERATOR_STEP_2_ROUTES = {
	url: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Url]}`,
	vCard: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.VCard]}`,
	menu: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Menu]}`,
	facebook: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Facebook]}`,
	pdf: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Pdf]}`,
	app: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.App]}`,
	plainText: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.PlainText]}`,
	images: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Images]}`,
	video: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Video]}`,
	businessPage: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.BusinessPage]}`,
	socialMedia: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.SocialMedia]}`,
	wifi: `/generator/${QR_TYPE_TO_PARAM[QR_TYPE.Wifi]}`,
} as const satisfies Record<QR_TYPE, string>

export const ROUTES = {
	// Public
	index: '/',
	altLanding: '/create',
	checkInboxModal: `/?${SEARCH_PARAMS.modals.key}=${SEARCH_PARAMS.modals.recoverPasswordConfirmation}`,
	resetExpiredModal: `/?${SEARCH_PARAMS.modals.key}=${SEARCH_PARAMS.modals.resetLinkExpired}`,
	prices: '/prices',
	about: '/about-us',
	terms: '/terms-of-use',
	privacyPolicy: '/privacy-policy',
	contact: '/contact-us',
	qrCodeMinimumSize: '/qr-code-minimum-size',
	cancelSubscription: '/cancel-subscription',
	faq: '/faq',
	inmobiWelcome: '/inmobi/welcome',
	qrDisabled: '/qr/disabled',
	qrDisabledLangProxy: '/api/qr-disabled-lang',
	completeSetup: '/complete-setup',
	completeSetupLangProxy: '/api/complete-setup-lang',
	notFound: '/404',
	forbidden: '/403',

	// Errors
	errors: {
		notFound: '/404',
		forbidden: '/403',
	},

	// Authentication
	auth: {
		login: '/login',
		signup: '/sign-up',
		recoverPassword: '/recover-password',
		resetPasswordLegacyLink: '/reset-password/:uri',
		expiredResetPassword: '/expired-reset-password-link',
	},

	plans: '/plans',

	// Generator
	generator: {
		...GENERATOR_STEP_2_ROUTES,
		typeStep: '/generator',
		designStep: '/generator/qr',
		signup: '/generator/sign-up',
		ai: '/generator/ai',
	},

	// Checkout
	checkout: {
		index: '/checkout',
		success: '/checkout/success',
		plans: '/checkout-plans',
		plansSuccess: '/checkout-plans/success',
		upgrade: '/checkout-upgrade',
		upgradeSuccess: '/checkout-upgrade/success',
	},

	// Pricing
	pricing: '/pricing',

	// Cabinet
	cabinet: {
		index: '/cabinet',
		qrCodes: '/cabinet/qr-codes',
		analytics: '/cabinet/analytics',
		account: '/cabinet/account',
		billing: '/cabinet/billing',
		help: '/cabinet/contact-us',
		statusRestrictedQrCodes: `/cabinet/qr-codes?${SEARCH_PARAMS.modals.key}=${SEARCH_PARAMS.modals.statusRestricted}`,
	},
} as const

export const GENERATOR_CONTENT_PAGE_LIST = [
	ROUTES.generator.url,
	ROUTES.generator.vCard,
	ROUTES.generator.menu,
	ROUTES.generator.facebook,
	ROUTES.generator.pdf,
	ROUTES.generator.app,
	ROUTES.generator.plainText,
	ROUTES.generator.images,
	ROUTES.generator.video,
	ROUTES.generator.businessPage,
	ROUTES.generator.socialMedia,
	ROUTES.generator.wifi,
] as const

export const NON_LEGACY_ROUTES = [
	ROUTES.index,
	ROUTES.altLanding,
	ROUTES.prices,
	ROUTES.plans,
	ROUTES.pricing,

	ROUTES.auth.login,
	ROUTES.auth.signup,
	ROUTES.auth.recoverPassword,
	ROUTES.auth.resetPasswordLegacyLink,

	ROUTES.cancelSubscription,
	ROUTES.inmobiWelcome,

	ROUTES.generator.app,
	ROUTES.generator.url,
	ROUTES.generator.typeStep,
	ROUTES.generator.vCard,
	ROUTES.generator.images,
	ROUTES.generator.wifi,
	ROUTES.generator.facebook,
	ROUTES.generator.designStep,
	ROUTES.generator.signup,
	ROUTES.generator.socialMedia,
	ROUTES.generator.businessPage,
	ROUTES.generator.plainText,
	ROUTES.generator.menu,
	ROUTES.generator.video,
	ROUTES.checkout.index,
	ROUTES.checkout.success,
	ROUTES.checkout.plans,
	ROUTES.checkout.plansSuccess,
	ROUTES.checkout.upgrade,
	ROUTES.checkout.upgradeSuccess,

	ROUTES.cabinet.index,
	ROUTES.cabinet.qrCodes,
	ROUTES.cabinet.analytics,
	ROUTES.cabinet.account,
	ROUTES.cabinet.billing,

	ROUTES.errors.notFound,
	ROUTES.errors.forbidden,
	'/qr/:uri/view',
	ROUTES.qrDisabled,
	ROUTES.completeSetup,
] as const
